import * as React from 'react'

import { Switch } from '~/client/src/shared/components/shadcn-ui/switch'

import { useResourceFieldContext } from '../ResourceFieldContext'

interface IProps {
  property: 'allowSelectExisting' | 'allowCreateNew'
  label: string
}

function FieldToggle({ property, label }: IProps): JSX.Element {
  const { field, onChange } = useResourceFieldContext()

  const checked = field[property] ?? true

  const otherProperty =
    property === 'allowSelectExisting'
      ? 'allowCreateNew'
      : 'allowSelectExisting'

  const handleToggle = React.useCallback(() => {
    const newChecked = !checked
    const otherChecked = field[otherProperty] ?? true
    if (!newChecked && !otherChecked) {
      onChange({ ...field, [property]: false, [otherProperty]: true })
    } else {
      onChange({ ...field, [property]: newChecked })
    }
  }, [field, onChange, checked, property, otherProperty])

  return (
    <div className="tw:h-10 tw:pr-4 tw:py-2.5 tw:inline-flex tw:justify-start tw:items-center tw:gap-3">
      <Switch checked={checked} onCheckedChange={handleToggle} />
      <span className="tw:text-label-lg tw:text-foreground">{label}</span>
    </div>
  )
}

export default FieldToggle
